import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AppScreenShell from "../../components/layout/AppScreenShell";
import InstallInstructions from "../../components/pwa/InstallInstructions";
import { usePWAInstall } from "../../components/pwa/PWAInstallContext";

export default function InstallIOS() {
  const navigate = useNavigate();
  const { installed } = usePWAInstall();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <AppScreenShell
      eyebrow="Install Gwin"
      title="iPhone / iPad installation"
      subtitle="Follow the Safari steps to add Gwin to your Home Screen."
      maxWidth="max-w-[430px]"
      showBottomBar={false}
    >
      <section className="rounded-[24px] border border-[#E7E7E7] bg-white p-5 shadow-sm">
        {installed && (
          <p className="mb-4 rounded-xl bg-[#EDF9F1] p-3 text-sm font-bold text-green-800">
            Gwin is already running as an installed app.
          </p>
        )}
        <InstallInstructions device="ios" />
      </section>
      <button
        type="button"
        onClick={() => navigate(-1)}
        className="mt-5 rounded-xl border border-[#DDDDDD] bg-white px-5 py-3 text-sm font-bold text-[#555555]"
      >
        Back
      </button>
    </AppScreenShell>
  );
}
